export const subtitles = {
    "1": {
        "startTime": 17.61,
        "endTime": 23.07,
        "transcript": "Tau͡gamtellu ayuqenrilamta wangkuta cugni",
        "translation": "And then, because we people are not the same"
    },
    "2": {
        "startTime": 24.112,
        "endTime": 39.037,
        "transcript": "Ayuqenrilamta qanellrak taukuk iliin, cuum iliin tau͡ga-i imutun tangenrilngurcetun niitellrunrilngurcetun-llu ayuqluku tau͡ga piarkaulliniluku.",
        "translation": "Since we are not the same, it will be like some people do not see and do not hear what they have said."
    },
    "3": {
        "startTime": 40.997,
        "endTime": 47.822,
        "transcript": "Tau͡gaten-am tauna qanruteknauraak tau͡gaten ayuqelria.",
        "translation": "They would talk like that about a person who is like that."
    },
    "4": {
        "startTime": 48.103,
        "endTime": 55.728,
        "transcript": "Ingna-gguq tekilluku Cuungaituq una, Cug'ungaituq.",
        "translation": "They said that in the future, he will not be Cup'ik, will not be Cup'ik."
    },
    "5": {
        "startTime": 56.472,
        "endTime": 67.984,
        "transcript": "Tau͡gken imna qaneryarartek cali maligtaqustii tamana murilkeqapiggluku, murilkellini[va]gaqluku tamaani qaygim iluanelnguum.",
        "translation": "However, they would closely aboserve the one who followed their traditional wisdom who is inside that community house."
    },
    "6": {
        "startTime": 68.46,
        "endTime": 80.66,
        "transcript": "Qaneryarameng maligtaqustii, maligtaqusteqapiaraat waten ak'arrarnun anerteqerciqniluku.",
        "translation": "They said that one who closely follows traditional wisdom like this would live for a long time."
    },
    "7": {
        "startTime": 81.367,
        "endTime": 90.367,
        "transcript": "Imumeng anernera uyungekanilriatun ayuqeciqniluku maligtaqulluni tauna pikan",
        "translation": "They say that it will be as if his breath squats down [?stays] if he is obedient"
    },
    "8": {
        "startTime": 90.461,
        "endTime": 98.436,
        "transcript": "Ilamineng-llu acivarciyuunani, ilamineng-llu waten upussakiyuunani.",
        "translation": "And he does not put down those around him, and he doesn't talk down to those around him."
    },
    "9": {
        "startTime": 98.542,
        "endTime": 109.842,
        "transcript": "Ayuqluki ayagyugarungraata mik'lengraata ayuqluki tau͡ga pisqeńauraat tau͡gaten cuk tauna taukuk qanelriit.",
        "translation": "Those who spoke would tell that person to treat everyone the same, even if they're young or small."
    },
    "10": {
        "startTime": 134.511,
        "endTime": 146.386,
        "transcript": "Tamarmeng taukut qanrut'lallruatnga, wiinga-gguq yurrluvakarlua, irnianek-llu-gguq akitekam iqukliqaarluku",
        "translation": "All of them would tell me that if I am a bad person, and if I disregard children after [?receiving money for them]"
    },
    "11": {
        "startTime": 146.905,
        "endTime": 151.905,
        "transcript": "Ayuquciqa nasperturluku uniciiqaanga uima.",
        "translation": "My husband would consider my behavior and leave me."
    },
    "12": {
        "startTime": 152.762,
        "endTime": 164.599,
        "transcript": "Tuamtell' cali, cali angutet, angun-gguq cali inerciigapakarluni",
        "translation": "And then men also, they said that if a man is too mischievous"
    },
    "13": {
        "startTime": 164.837,
        "endTime": 179.037,
        "transcript": "Tua-i cali tuaten irnianek cali akini iqukliqaarluku unitelarait qanrucunaipakalriit.",
        "translation": "They leave those who do not take advice when they also disregard children after [receiving money for them]."
    },
    "14": {
        "startTime": 180.881,
        "endTime": 186.806,
        "transcript": "Tua-i-ll' sagtengluteng uingesciigaliluteng.",
        "translation": "And then they scatter and are unable to take husbands."
    },
    "15": {
        "startTime": 186.825,
        "endTime": 192.862,
        "transcript": "Tuamtell' cali angun nulirturciigaliluni nallunriatni yuut.",
        "translation": "And then a man can't take a wife since people know about him."
    },
    "16": {
        "startTime": 216.3,
        "endTime": 229.85,
        "transcript": "Niitlalriakut-llu canek makunek neqkamteńek, qang'a-llu arnani wangkuta mingqaamteńek aturall'erkanek, kia-gguq piusngaitaakut.",
        "translation": "We also hear about these things, our food, and what we women sew into clothes, that no one will do it for us."
    },
    "17": {
        "startTime": 229.857,
        "endTime": 232.319,
        "transcript": "Wangkutnek-gguq pingnaqciqaput.",
        "translation": "They said we must work for them ourselves."
    },
    "18": {
        "startTime": 232.557,
        "endTime": 245.22,
        "transcript": "Tua-i tauna irniarput tuaten assiicukan, niicunricukan-llu, tua-i iqlutuuyukan, kia qagkut piusngailngataakut.",
        "translation": "If our child has bad behavior like that, and is disobedient, and a liar, no one out there will take care of that for us."
    },
    "19": {
        "startTime": 245.32,
        "endTime": 250.432,
        "transcript": "Wangkuta wangkutnek tau͡gaam pingnaqluku piciqerput.",
        "translation": "We will only do it ourselves."
    },
    "20": {
        "startTime": 252.683,
        "endTime": 260.32,
        "transcript": "Tua-i-gguq una tan'gaurluq, au͡gkut yuut qaneryaraqekiit Yupiit.",
        "translation": "Yupiit back then have traditional wisdom concerning boys."
    },
    "21": {
        "startTime": 260.583,
        "endTime": 264.358,
        "transcript": "Tan'gaurluq-gguq una cimiryuumauq.",
        "translation": "They say that a boy is able to change."
    },
    "22": {
        "startTime": 265.014,
        "endTime": 271.039,
        "transcript": "Yuucini-gguq quinagyagutarkaugaa.",
        "translation": "They say that he will become repulsed with his life."
    },
    "23": {
        "startTime": 272.72,
        "endTime": 280.72,
        "transcript": "Una-gguq, tauna-llu tua-i arcaqerluku alikelqa tamaani tua-i murilkengamki qaneryarat.",
        "translation": "They said this, and I was especially afraid of that back when I started observing the traditional wisom."
    },
    "24": {
        "startTime": 281.214,
        "endTime": 292.014,
        "transcript": "Una-gguq tau͡gken arnaq tuaten ayuqekuni caperrnarqenruuq cimillerkaa yuucini, piciryarani.",
        "translation": "However, they said that if a woman is like that, it is more difficult for her to change her life, her ways."
    },
    "25": {
        "startTime": 292.046,
        "endTime": 298.483,
        "transcript": "Iciw' tamaaken kanaken ayagluku cimircetengnaqenrilkumteggu.",
        "translation": "You know, if we do not try to change them [for the better] starting from when they're small."
    },
    "26": {
        "startTime": 299.708,
        "endTime": 314.046,
        "transcript": "Cimiryaaqeciqaa-gguq waten iciw' au͡gani wangkutnek uingyuitellemteńi, uingyuitellermeggni.",
        "translation": "They said that she may change, you know, back when we didn't choose our own husbands, when they didn't choose their own husbands."
    },
    "27": {
        "startTime": 314.734,
        "endTime": 325.571,
        "transcript": "Cimiryaaqeciqaa-gguq uum waten-llu ukurriskuni ak'anivekanku-gguq ayuqucivialuni ataam teguciqaa.",
        "translation": "They said that she may change when she moves into her in-laws, but she will take upon her former ways again."
    },
    "28": {
        "startTime": 326.059,
        "endTime": 337.109,
        "transcript": "Tuatelluku arnani wangkuta ayagmek tua-i ellicangnaqluta-llu ayuqucirtungnaqluta-llu pitullinikaitkut.",
        "translation": "Through that, they would evidently try to teach and instruct us women from the beginning."
    },
    "29": {
        "startTime": 360.828,
        "endTime": 372.316,
        "transcript": "Tua-llu wangkuta maa-i tuaten niicunrilengraan, taangamek-llu niicunrilengraan tua-i piqa'aqluku.",
        "translation": "And then, even if they're disobedient, or do not heed [advice] on alcohol, to talk to them."
    },
    "30": {
        "startTime": 373.029,
        "endTime": 381.779,
        "transcript": "Taangarniluku-llu cellangengraan uumik'ngartevkenaku tangellrani.",
        "translation": "And even if he comes to, do not treat him badly because of his alcohol use when seeing him."
    },
    "31": {
        "startTime": 383.623,
        "endTime": 395.948,
        "transcript": "Tau͡gaam kenkellerput nasvaumaluku. Nallunricetengnaqluku kenkellerput iciw' aanaulriani kenkellerput.",
        "translation": "Instead, show them our love. Try to let them know our love, you know, our mother's love."
    },
    "32": {
        "startTime": 396.292,
        "endTime": 406.317,
        "transcript": "Cali taangiqnginanrani uumikualuku pivkenaku.",
        "translation": "Also, do not treat him badly as he's drunk."
    },
    "33": {
        "startTime": 406.673,
        "endTime": 416.598,
        "transcript": "Cali enemteńi tamaani uitaluni avaqliqnginanemteńi tuaten piyukan qimagavkenaku.",
        "translation": "Also, if he does that in our house around us, do not run from him."
    },
    "34": {
        "startTime": 417.792,
        "endTime": 425.267,
        "transcript": "Alingnarqengnaqluni-ll' piyaaqeciqngatuq, ingluturtailkuni pingaituq.",
        "translation": "He may act scary, but he will not do anything if he has no one to go against him."
    },
    "35": {
        "startTime": 429.448,
        "endTime": 440.798,
        "transcript": "Cali taangiqellran kinguani assinrilngurmek-llu iciw' tamaani-llu enemi pingraan, wiinga-wa ayuquciqaqa.",
        "translation": "Also, after he's drunk and did something bad, you know, in that house, at least this is what I'm like."
    },
    "36": {
        "startTime": 441.517,
        "endTime": 452.967,
        "transcript": "Qimanritengnaqluku, unitenritengnaqluku. Iciw' alikenruaqa kingumni qaill' pillerkaa.",
        "translation": "Try not to run away from him, try not to leave him. You know, I'm more afraid of what he may do behind me."
    },
    "37": {
        "startTime": 454.599,
        "endTime": 462.599,
        "transcript": "Naliak-llu cumilnguluni uniskumteńi kiirrarmi-llu tamaani pikuni, naliak-ll' cumilnguciquq.",
        "translation": "And if one is offended, and we leave him all alone there, one of them will be offended."
    },
    "38": {
        "startTime": 462.606,
        "endTime": 469.118,
        "transcript": "Qang'a-llu-qaa caskumek tegulluni ellminek akngirtengnaqluni-ll' piciquq.",
        "translation": "Or else, he may take a weapon and try to hurt himself."
    },
    "39": {
        "startTime": 492.206,
        "endTime": 505.519,
        "transcript": "Cali tuaten unuaquani tauna irniaqa taangiqellrukan, unuaquani qarulluku, egmian-llu nunurpek'naku.",
        "translation": "And the next day if my child had been drunk, console him the next day, and don't scold him right away."
    },
    "40": {
        "startTime": 507.181,
        "endTime": 519.581,
        "transcript": "Qarulluku imucetun pilallemtun camek quyacetaarluku apluku-llu, apluku caqatallranek-llu. Tauna kiingan.",
        "translation": "Console him as I did before to try to make him happy, and ask him what he's going to do. Just that."
    },
    "41": {
        "startTime": 519.938,
        "endTime": 528.3,
        "transcript": "Taangiqellra akwaugaq, qenqerrartellrukan-llu qenqertellra-ll' ciumek alairtevkenaku.",
        "translation": "With his being drunk the day before, do not first bring up his anger if he had become angry."
    },
    "42": {
        "startTime": 529.088,
        "endTime": 538.263,
        "transcript": "Wiinga-llu alingellrukuma tua tamakut puggerqevkenaki, tau͡gaam qarulluku.",
        "translation": "And if had been scared, do not bring those up, but console him."
    },
    "43": {
        "startTime": 538.732,
        "endTime": 545.107,
        "transcript": "Qanerlalriit-llu maa-i, tangerrlaqenka-llu wii hangover-arluteng, yuussugluteng.",
        "translation": "And they say now, and I see them being hungover, yuussugluteng."
    },
    "44": {
        "startTime": 545.351,
        "endTime": 549.926,
        "transcript": "Naliak-ll' yuussuinanermini qenqercukaarngatuq.",
        "translation": "And if one of them is hungover, he seems to be irritable."
    },
    "45": {
        "startTime": 550.857,
        "endTime": 564.645,
        "transcript": "Tuatnanriqan tau͡gaam anglaningkan, cangkan, qanenqegcangluni-llu pikan, tuani-w' tua-i hangover-aallermini-ll' qanenqegcanrilngatuq.",
        "translation": "Only when he stops that and starts having fun, starts doing things, when he can speak well, well, he doesn't seem to be able to speak well when he's hungover."
    },
    "46": {
        "startTime": 566.283,
        "endTime": 575.445,
        "transcript": "Qanenqegcarluni-llu pingkan nutaan neryuniunrillrani-llu",
        "translation": "And when he starts to speak well and doesn't expect [to be scolded] anymore"
    },
    "47": {
        "startTime": 575.583,
        "endTime": 583.208,
        "transcript": "Nutaan akwaugarpaimainanrani-llu qang'a-llu-qaa nutaan taumek qanrulluku.",
        "translation": "Then, one should talk to him about what had happened the previous day."
    },
    "48": {
        "startTime": 583.414,
        "endTime": 588.614,
        "transcript": "Nunurpek'naku-llu qanenqegcaaraulluku tau͡gaam.",
        "translation": "And do not scold him, but speak kindly to him."
    },
    "49": {
        "startTime": 588.683,
        "endTime": 600.933,
        "transcript": "Qaillun elpet alingellren, qaillun-llu unitellerkaanek alingellren nalqigulluku, nalqigutepiggluku nunuavkenaku.",
        "translation": "Explain to him, clearly explain to him how you were scared and how you would leave your fear without scolding him."
    },
    "50": {
        "startTime": 602.99,
        "endTime": 609.215,
        "transcript": "Naliak tuani umyuarniurciquq cakneq.",
        "translation": "One of them will be very regretful then."
    },
    "51": {
        "startTime": 610.071,
        "endTime": 616.846,
        "transcript": "Umyuarniurluni. Kenekniluku-llu, kenkellren-llu nasvagluku.",
        "translation": "He will regret it. And tell him you love him, and show him your love."
    },
    "52": {
        "startTime": 641.015,
        "endTime": 648.302,
        "transcript": "Alerqutulqaakut imna yuussuun elegcimun pitukiit. Nallunrilngatan. (Yaa.)",
        "translation": "They would instruct us on hooks for dragging caught seals that they put on gaffs. You seem to know it. (Yes.)"
    },
    "53": {
        "startTime": 648.315,
        "endTime": 655.89,
        "transcript": "Yuussuun tamana imarpiqukumta tegumiaqesqelluku unitaayuunaku.",
        "translation": "They said that if we travel in the ocean, to keep that hook in possession without leaving it behind."
    },
    "54": {
        "startTime": 655.909,
        "endTime": 663.771,
        "transcript": "Natmun ayagaqamta nascarturaqamta-llu unitevkenaku, ayaruqluku tau͡gaam pisqelluku.",
        "translation": "If we go somewhere or go to look from a vantage point, we shouldn't leave it, but use it as a staff."
    },
    "55": {
        "startTime": 663.959,
        "endTime": 677.959,
        "transcript": "Tau͡ga tamaa-i tamana picurlagarkaq tamatum-wa tamatum elegciim tau͡gaten ang'aqluku piaqamiu tamatum tau͡gaam pivkaraqaa.",
        "translation": "With his potential to get into misfortune, when he takes that gaff along with him, that [saves] him."
    },
    "56": {
        "startTime": 678.053,
        "endTime": 690.416,
        "transcript": "Caqerluni ataataka, aatama atii nascartulliuq imkunun qertulrianun etgalirralrianun.",
        "translation": "One day, my grandfather, my father's father, went to look from a high vantage point where it was a little shallow."
    },
    "57": {
        "startTime": 691.128,
        "endTime": 702.416,
        "transcript": "Pikani-am, pikani-am nassesngainanrani tamana atam tegumiaqluku, imkut ustelliniluteng.",
        "translation": "As he was looking around from up there holding that, they started caving."
    },
    "58": {
        "startTime": 702.704,
        "endTime": 713.879,
        "transcript": "Tau͡ga piata, ellii-llu pian, piami-wa tau͡gaten ikakaata wanigg' piqataata, piata-wa elegcini piluku.",
        "translation": "When that happened and he also wend down, as they were [?crumbling], he did this with his gaff."
    },
    "59": {
        "startTime": 713.898,
        "endTime": 718.873,
        "transcript": "Taumun agaqalliniluni, mermun, mermun-wa pivkenani.",
        "translation": "He hung on to that, and didn't go into the water."
    },
    "60": {
        "startTime": 719.229,
        "endTime": 726.542,
        "transcript": "Cali wii tamatum cali anirtulqaanga malrurqugnek.",
        "translation": "That has also saved me twice."
    },
    "61": {
        "startTime": 726.554,
        "endTime": 731.779,
        "transcript": "Elegciim tau͡ga tamaa-i alerqutii tamana, alerquutii.",
        "translation": "That is the instruction on the gaff, the instruction."
    },
    "62": {
        "startTime": 731.794,
        "endTime": 741.544,
        "transcript": "Aipaan camna ekqatallemni ussullua elegciim cali tamatum cali qelulqaanga.",
        "translation": "The other time, when I was going to go in as it collapsed under me, that gaff pulled me out."
    },
    "63": {
        "startTime": 742.4,
        "endTime": 759.425,
        "transcript": "Cali pektellemni cikuillrulleq tumekluku, tumekluku tegumiaqenrilkumku tamana tau͡gani qanikcaqallrani kiskuma egmian tam' igcartua.",
        "translation": "Also, when I was traveling with thinner ice in my path, had I not had that in my possession when it was snowy, if I sunk, I would have fell in right away."
    },
    "64": {
        "startTime": 759.475,
        "endTime": 770.125,
        "transcript": "Tamatum cali tau͡ga-i tamaa-i alerquutii tamana. Waten tau͡ga piluku kic'itellrunritaanga.",
        "translation": "That's also the instruction concerning that. I did this and it kept me from sinking."
    },
    "65": {
        "startTime": 796.424,
        "endTime": 806.824,
        "transcript": "Aki una quyurarrluni piaqan assirturiartuq tau͡gani-w' quyungqaqallrani",
        "translation": "When this money is gathered, it's good when it's gathered there"
    },
    "66": {
        "startTime": 806.925,
        "endTime": 817.975,
        "transcript": "Cakaminun atu'urkaminun, culukurkanun, qang'a-ll' angyarkanun quyungqaqallrani yuum ikayuutekuniu tunkuniu.",
        "translation": "To things he need to use, [culukarkat], or boats as it's gathered, if he gives it to help a person."
    },
    "67": {
        "startTime": 818.487,
        "endTime": 833.424,
        "transcript": "Taumeng-am wanigga maa-i, maa-i-wa waten yuk akiliqluni piaqan akim tau͡ga-i iliin taum ayimlluku piyuria watua.",
        "translation": "That's why these days, when a person is paid, that money makes it make or break for them now."
    },
    "68": {
        "startTime": 833.899,
        "endTime": 847.437,
        "transcript": "Uumeng wanigga yuk akingluni piaqami, piaqami-wa tangvak'nganka keggani man'a-wa kemnillrat arcaqaruuq.",
        "translation": "When a person gets money, for the ones I see outside, getting drunk is the most important for them."
    },
    "69": {
        "startTime": 847.8,
        "endTime": 863.987,
        "transcript": "Iqluggun tamana tau͡gaten cakamineng pikuni aturarkani tamaaggun aturluku, cali ayagaluni pilegnun tamaavet cali catmun aturluku.",
        "translation": "If he uses it the wrong way to get some substances, and if he travels to places where they have them, he uses it for those things."
    },
    "70": {
        "startTime": 864.249,
        "endTime": 869.787,
        "transcript": "Iliini picurlautekluku piaqluku-wa.",
        "translation": "It sometimes brings him to misfortune."
    },
    "71": {
        "startTime": 895.474,
        "endTime": 909.324,
        "transcript": "Uumeng wanigga qanelriit tau͡ga ukuk wanigga pikairutkunilukek qanrutulqaitkut qavankuk qessa-llu.",
        "translation": "The people who spoke on this told us that sleep and laziness keep us destitute."
    },
    "72": {
        "startTime": 909.537,
        "endTime": 910.912,
        "transcript": "Taukuk tau͡ga.",
        "translation": "Those two."
    },
    "73": {
        "startTime": 911.124,
        "endTime": 917.487,
        "transcript": "Tau͡ga-gguq yuum taukuk tau͡ga cakairutkek.",
        "translation": "They say those two deprive people of things [they need]."
    },
    "74": {
        "startTime": 917.95,
        "endTime": 931.8,
        "transcript": "Tau͡gaam una qaneryaraq elisngaluku [tuka]luggluni pilria man'a pikegtaq maligngaluku pilria yuk",
        "translation": "But one who is knowledgeable about traditional wisdom, [raised right], a person who follows good things"
    },
    "75": {
        "startTime": 932.087,
        "endTime": 940.524,
        "transcript": "Wii-llu tau͡gaten-wa pilriit tamakut tangvatullrenka cakaituravakallrunritut.",
        "translation": "The ones I saw doing that were not in need of anything too much."
    },
    "76": {
        "startTime": 940.862,
        "endTime": 950.612,
        "transcript": "Cali pitqayuluteng pillruut, tamana-wa alerquun assilria atuamegteggu.",
        "translation": "They were also good hunters because they followed that good instruction."
    },
    "77": {
        "startTime": 950.85,
        "endTime": 953.737,
        "transcript": "Civunra catangqeqeryugluni.",
        "translation": "There were often things up ahead for him."
    },
    "78": {
        "startTime": 953.8,
        "endTime": 967.012,
        "transcript": "Wangkuta cillangellemteńi qaqimeng mat'umeng pillrunrilamta tau͡gaam pitakun-wa pitamteggun tau͡ga cangengnaqtullruamta",
        "translation": "When we were growing up, because we didn't have things premade for us since we only tried to make things out of what we caught"
    },
    "79": {
        "startTime": 967.274,
        "endTime": 975.224,
        "transcript": "Tau͡ga tau͡gaten qanrutulqaitkut piculuta catqayuluta pisqelluta.",
        "translation": "They would tell us that, to try to be good at hunting and catching."
    },
    "80": {
        "startTime": 975.412,
        "endTime": 991.687,
        "transcript": "Tamaa-i tamakut qanruquralqaitkut tamatum cakaituranricaram tungiikun yuulria pitqayuluni picuitevkenani yuullruuq.",
        "translation": "They told us about that, that one who lives without being in need of anything lived as a good hunter, not a bad hunter."
    },
    "81": {
        "startTime": 1015.212,
        "endTime": 1026.062,
        "transcript": "Kina imna camek pingnatulria, arcaqerluni-llu taangamek pingnatulria, qang'a-llu-qaa mat'umek melullermek pingnatulria",
        "translation": "If someone works for something, especially one who works for alcohol, and even one who works for smoking"
    },
    "82": {
        "startTime": 1027.45,
        "endTime": 1034.787,
        "transcript": "Camek ukvelirluni, ikayurcirluni piarkaungatuq wangni.",
        "translation": "To me, it seems he must believe in something, and seek help."
    },
    "83": {
        "startTime": 1036.712,
        "endTime": 1042.637,
        "transcript": "Ukveritqapiarluni yuk ping'e'rmi kayungqerrngaituq.",
        "translation": "If a person has absolutely no faith, he will have no strength though he tries."
    },
    "84": {
        "startTime": 1044.862,
        "endTime": 1054.7,
        "transcript": "Aipaagnek ukverluten. Agayuvik, agayuviim piciryaraa ukvekluku.",
        "translation": "Believe one of the two. Believe in the ways of the church."
    },
    "85": {
        "startTime": 1055.049,
        "endTime": 1067.312,
        "transcript": "Ukvekesciigalkuvgu-llu agayuviim piciryaraa, Yupiit qantuut agayuviim alerquutain cangalqenrilkaitnek.",
        "translation": "And if you cannot believe in the ways of the church, Yupiit speak things that are no different from the instructions of the church."
    },
    "86": {
        "startTime": 1067.724,
        "endTime": 1074.612,
        "transcript": "Yupiit qaneryarait ukvekluki agayuviim piciryarai piyunrilkuvki.",
        "translation": "Believe in Yup'ik wisdom if you do not wat the church's ways."
    },
    "87": {
        "startTime": 1074.887,
        "endTime": 1082.862,
        "transcript": "Yupiim qaneryaraa ukvekluku, atungnaqluku, cali niitengnaqluku.",
        "translation": "Believe in Yup'ik wisdom, try to adhere to it, and try to obey it."
    },
    "88": {
        "startTime": 1083.75,
        "endTime": 1097.675,
        "transcript": "Cangalliurngaituq Yup'ik iciw' ak'allaurteqalria apeskani yuum ayuqucirtuutmek ciunerkamek apeskani.",
        "translation": "A Yup'ik will not mind, you know, if person asks an elder about instructions, asks about what do to in the future."
    },
    "89": {
        "startTime": 1097.687,
        "endTime": 1105.412,
        "transcript": "Wangni quyaciquq cakneq. Cakneq taumek apeskani quyaciquq wangni.",
        "translation": "To me, he will be very thankful. To me, he will be very thankful if he asks him."
    },
    "90": {
        "startTime": 1106.224,
        "endTime": 1115.824,
        "transcript": "Wii maa-i calinring'e'rma-llu yuut ap'artaqatnga cakneq qamaken ircaqumnek quyalua pitacimtun.",
        "translation": "Even though I am not working anymore now, when people ask me, I am wholeheartedly thankful inside."
    },
    "91": {
        "startTime": 1115.937,
        "endTime": 1128.824,
        "transcript": "Qaneryararrarmek Yup'igtarrarmek waniwa arnangiaraurcama arcaqerlua imkut Yup'igtaat tuarpiaq kayuriluteng wangnun taiguq.",
        "translation": "That traditional Yup'ik wisdom, especially now that I am an old lady, it seems that that Yup'ik wisdom comes to me more strongly."
    },
    "92": {
        "startTime": 1129.512,
        "endTime": 1134.537,
        "transcript": "Tua-i-wa cangallrunritliniata mat'umi agayuviim qaneryaraani.",
        "translation": "It's because they're no different from the church's wisdom."
    },
    "93": {
        "startTime": 1134.674,
        "endTime": 1144.962,
        "transcript": "Tua-i cakneq kayuqapiggluteng, assiqapiggluteng-llu wangni qaneryaraulliniut au͡gkut Yupiit qaneryarait, alerquutait.",
        "translation": "They are very strong and very good traditional wisdom to me, that Yup'ik wisdom and instruction."
    },
    "94": {
        "startTime": 1170.424,
        "endTime": 1181.524,
        "transcript": "Qanrutellruaqamki pilaranka, \"Kenekngamci ukanirpak wii taangangnaqellrunritua nanikuasqenrilamci.\"",
        "translation": "When I spoke to them, I would tell them, \"Since I love you, I have always refrained from drinkins because I don't want you to feel helpless.\""
    },
    "95": {
        "startTime": 1181.737,
        "endTime": 1187.399,
        "transcript": "Tangerrlaata-llu ilameggnek taangiqellrianek-llu angayuqaalegnek.",
        "translation": "It's also because they see their peers have alcoholic parents."
    },
    "96": {
        "startTime": 1187.412,
        "endTime": 1195.962,
        "transcript": "Kusguryugluteng-llu itrutlaata nerucugluki-llu. Mom-ii-gguq daddy-llu taangiquq.",
        "translation": "Also, they bring them in in shame wanting to feed them. They say their mom and daddy are drunk."
    },
    "97": {
        "startTime": 1196.412,
        "endTime": 1203.349,
        "transcript": "Tua-i takumcuyullratnek cakneq quyatullruunga cakneq ilumnek.",
        "translation": "I would be extremely thankful inside that they were compassionate."
    },
    "98": {
        "startTime": 1204.887,
        "endTime": 1216.287,
        "transcript": "Tua-i qanrutlaqenka tamatumek tuaten: \"Kenekngamci wii nanikuavkangnaqluci anglicallrunritamci.",
        "translation": "I would them about that like that: \"Since I love you, I didn't raise you by making you feel helpeless."
    },
    "99": {
        "startTime": 1217.2,
        "endTime": 1233.737,
        "transcript": "\"Akinaurlua-llu elpeci kenkepigglua tuaten taangamek tamatumek pisqumanritlemnek umyuaqlua pinritengnaqaqluci pici.\"",
        "translation": "\"To pay me back out of great love for me, remember that I do not want you do abuse that alcohol, so keep away from it.\""
    },
    "100": {
        "startTime": 1233.8,
        "endTime": 1236.6,
        "transcript": "Tua-i taumek tuaten qanrutlaranka.",
        "translation": "That's what I tell them."
    },
    "101": {
        "startTime": 1259.6,
        "endTime": 1265.4,
        "transcript": "Watua maa-i arcaqerluteng caperrnarivsiartut waten:",
        "translation": "These days especially, they are getting more difficult like this:"
    },
    "102": {
        "startTime": 1266.549,
        "endTime": 1276.9,
        "transcript": "Wangkuta Yup'igni, Kass'am-llu piciryaraan akuliigni qukaani tuarpiaq maku'urluut",
        "translation": "It truly seems that these poor people are caught in the middle of Yup'ik and Western cultures"
    },
    "103": {
        "startTime": 1277.012,
        "endTime": 1283.562,
        "transcript": "Wiinga waniwa tutgara'urluunka ukut tua-i akuliigni tuar uitalriit.",
        "translation": "It's like my grandchildren here are caught between them."
    },
    "104": {
        "startTime": 1284.249,
        "endTime": 1294.999,
        "transcript": "Pingraan tau͡gaam tua-i, nani maani-llu qitevterrlainarluteng-llu maa-i tutgara'urluput, wiinga-w' tutgara'urluunka pingut.",
        "translation": "But despite that, in some places here, our grandchildren, at least my grandchildren, are starting to speak only in English."
    },
    "105": {
        "startTime": 1295.612,
        "endTime": 1303.225,
        "transcript": "Tua-i puqigtacirramtun nani maani qanrusnguaqangnaqa'artaqluki pilaryaaqanka.",
        "translation": "I try to speak to them around here with whatever [English] fluency I have."
    },
    "106": {
        "startTime": 1303.449,
        "endTime": 1312.487,
        "transcript": "Tuarpiaq niicugniyuumiilnguut-llu pilkiagaqluteng, qang'a-llu-qaa piciunrilkelkialuki tuaten cali pilkiagaqluteng.",
        "translation": "It truly seems that they show that they do not want to listen, or they also indicate that they do not think they are true."
    },
    "107": {
        "startTime": 1312.799,
        "endTime": 1319.224,
        "transcript": "Tau͡gaam tua-i pingraata tuaten pingnaqaqluki pinarqelliniut.",
        "translation": "But even though they do that, we must try [to teach] them like that."
    },
    "108": {
        "startTime": 1319.924,
        "endTime": 1327.712,
        "transcript": "Cali tuaten arcaqalriamek niicunritniluku tuatequanarqenritliniuq.",
        "translation": "Especially also like that, we must not [give up] like that because they don't want to listen."
    },
    "109": {
        "startTime": 1328.062,
        "endTime": 1337.324,
        "transcript": "Niitenrilengraan cam iliini umyuarniurciquq qaruqurteḿinek uumek.",
        "translation": "Even if he doesn't listen, he will someday have regrets about one that encouraged him."
    },
    "110": {
        "startTime": 1337.374,
        "endTime": 1342.824,
        "transcript": "Keneksukluni cam iliini umyuarteqciquq, umyuarteqciqliniuq.",
        "translation": "He will someday think that he was shown love."
    },
    "111": {
        "startTime": 1343.199,
        "endTime": 1356.474,
        "transcript": "Wiinga tua-i imkut anglillemni kenkenricuklua umyuarteqlallrulrianga tamakut tuaten qanrutestenka.",
        "translation": "When I was growing up, I used to think that those who taught me like that were not showing me love."
    },
    "112": {
        "startTime": 1357.95,
        "endTime": 1362.075,
        "transcript": "Cunawa keneklua qanrutlallrullinikiitnga.",
        "translation": "It turned out that they spoke to me out of love."
    },
    "113": {
        "startTime": 1362.087,
        "endTime": 1368.437,
        "transcript": "Tamana tua-i naspertukluku tua-i maa-i qanrutengnaqu'urlaranka.",
        "translation": "With that in consideration, I try to speak to them now."
    },
    "114": {
        "startTime": 1393.949,
        "endTime": 1402.937,
        "transcript": "Maa-i mat'um nalliini cali makunek ayagyuamteńek ellmeggnek pilriit amlleriut ayagyuaput makut.",
        "translation": "These days, there are also a lot of our young people that take their own lives."
    },
    "115": {
        "startTime": 1403.0,
        "endTime": 1408.362,
        "transcript": "Tua-i ellmeggnek piluteng, anernerteng kep'aqluku ellmeggnek.",
        "translation": "They end their own lives."
    },
    "116": {
        "startTime": 1408.662,
        "endTime": 1414.887,
        "transcript": "Wall'u callualuteng tuquutaqluteng, ilateng piunriraluki.",
        "translation": "Or the fight and kill each other, kill their peers."
    },
    "117": {
        "startTime": 1415.312,
        "endTime": 1427.937,
        "transcript": "Tua-i ilumun ayagyuaq una, ayagyuaqegtaar una ellminek pillra qununarqelaryaaquq cakneq.",
        "translation": "Truly, we do not want to lose a young person, a precious young person, who takes his own life."
    },
    "118": {
        "startTime": 1428.512,
        "endTime": 1434.85,
        "transcript": "Tua-i tayima makut ayagyuaput, yugni ayuqenritukut.",
        "translation": "About our young people, we people are not the same."
    },
    "119": {
        "startTime": 1434.862,
        "endTime": 1451.187,
        "transcript": "Ilaita angayuqrita-llu eq'ukluki wall'u tamana atutussiyaagniluku pivakarqaceteng man'a unguvallerkarteng cup'gut'laraat unguvayuumiirulluteng.",
        "translation": "Some people are treated badly by their parents, or when they are constantly told that they are doing something wrong, they lose their will to live, not wanting to live."
    },
    "120": {
        "startTime": 1451.724,
        "endTime": 1468.362,
        "transcript": "Tua-i-llu yuk waten tamatumek atutuluni ellmini assiirulluni ellminek, uitacurlallni naspqerturluku tua-i ellminek tayima anerneni kep'laryaaqaa.",
        "translation": "And then when a person does that and starts to think of himself as bad, he considers his conflict and takes his own life."
    },
    "121": {
        "startTime": 1468.574,
        "endTime": 1476.662,
        "transcript": "Tau͡gaam ellminek kep'ngermiu allamun assilriamun ellangengaituq.",
        "translation": "But even if he ends it himself, he will not awake to paradise."
    },
    "122": {
        "startTime": 1476.7,
        "endTime": 1484.687,
        "transcript": "Tau͡gaam assiilngurmi ellmi nunakiuraminun ellangeciquq. Pinrilngaunani-llu.",
        "translation": "Instead, he will awake in a bad place that he set for himself. And it will definitely happen."
    },
    "123": {
        "startTime": 1484.849,
        "endTime": 1501.137,
        "transcript": "Kitak' tang wangkuta angayuqrulriani irniaput tua-i pitungraata anagulluki apqiitnek pitukessiyaagpek'naki, pitukluki eq'uyagutevkenaki-llu, tau͡gaam qarutmek.",
        "translation": "So, no matter what our children do, let us parents not excessively blame them, as they call it, blame them and start treating them badly, but with encouragement."
    },
    "124": {
        "startTime": 1501.662,
        "endTime": 1506.737,
        "transcript": "Qarutmek tau͡gaam inerquagurangnauput.",
        "translation": "Let us only admonish them with encouragement."
    },
    "125": {
        "startTime": 1507.075,
        "endTime": 1518.687,
        "transcript": "Arenqiatuq maa-i mat'um nalliini piciryaraqliutaa ayagyuam tamarmi tua-i, ayagyuanrilnge'rmi-llu tua-i atutuluku.",
        "translation": "It's unfortunate these days that every young person has taken upon that way, and even those who are not young do it."
    },
    "126": {
        "startTime": 1545.562,
        "endTime": 1553.0,
        "transcript": "Makut-wa tang avatiitni ircenrrarugaat, uurcartangnaurtuq-llu.",
        "translation": "You see, there were a lot of legendary little people, and those carrying signaling gaffs would appear."
    },
    "127": {
        "startTime": 1553.099,
        "endTime": 1557.612,
        "transcript": "Nunanun-llu waniw' tekitarkaurrluni uurcaq taun' tamarluni.",
        "translation": "And when that one with the signaling gaff was going to reach the village, he would disappear."
    },
    "128": {
        "startTime": 1557.787,
        "endTime": 1566.899,
        "transcript": "Tamaqertelluku-llu maaken caniatnek, ikamrat makut qavciunguluteng-llu tayim' ketmurrluteng.",
        "translation": "And when he disappeared beside them, there would a certain number of sleds going down to the ocean."
    },
    "129": {
        "startTime": 1567.675,
        "endTime": 1576.175,
        "transcript": "Ketmurqaarluteng yuut taukut nunat ukut up'nerkilriit ciungatni piurluteng tamakut ircenrraat.",
        "translation": "After the people from this village who were at spring camp went down to the ocean, those little poeple would be ahead of them."
    },
    "130": {
        "startTime": 1576.425,
        "endTime": 1579.612,
        "transcript": "Ciunatni tua-i piurluteng.",
        "translation": "They were all ahead of them."
    },
    "131": {
        "startTime": 1584.887,
        "endTime": 1594.625,
        "transcript": "Ikamrat makut ketmurqaarluteng kelutmurrnaurtut. Ikamrait-wa kavirpak imaqaarluteng unguvalrianek.",
        "translation": "After those sleds went to the ocean, they would go inland. Their sleds were red, filled full with animals."
    },
    "132": {
        "startTime": 1595.537,
        "endTime": 1606.987,
        "transcript": "Tua-i-ll' atakuqerluku tayima tua-i ikamrat imkut maani tua-i ingrik tungiignun tayim' ayagaqluteng.",
        "translation": "And then right when evening set, those sleds here would go toward the two mountains."
    },
    "133": {
        "startTime": 1632.787,
        "endTime": 1641.437,
        "transcript": "Atakuqerluku nutaan uurcartangluni waken nunanek kingunelegmek up'nerkilriani.",
        "translation": "Right when evening set, there would be one with a signaling gaff who was from this spring camp settlement."
    },
    "134": {
        "startTime": 1642.762,
        "endTime": 1650.762,
        "transcript": "Tua-i-llu qasgitangqellruuq elatemteggun qasgigpagmek, qasgigpaarayagarmek.",
        "translation": "And then there was a community house outside of us, a big community house, quite a big community house."
    },
    "135": {
        "startTime": 1651.537,
        "endTime": 1661.274,
        "transcript": "Ap'a'urlurput una Elngum-gguq una atii tailuni qasgim kepneranun pikavet aqumqerluni.",
        "translation": "Our grandfather, whom they said was Elnguq's father, came and sat up there on the community house's flooded entrance."
    },
    "136": {
        "startTime": 1661.349,
        "endTime": 1667.074,
        "transcript": "Un'a uurcaq tagelria ukavet tua-i aturpauqurluku.",
        "translation": "He kept singing to that person with the signaling gaff coming inland toward us."
    },
    "137": {
        "startTime": 1667.424,
        "endTime": 1676.049,
        "transcript": "Wangkuta-w' tua-i naseknagni tan'gaurluut-llu unglumakevut ungluluku niicugnikvut.",
        "translation": "And we girls and boys listened to him as we held the ones we were hugging."
    },
    "138": {
        "startTime": 1676.6,
        "endTime": 1681.099,
        "transcript": "Aren, kiituani tang yuarutii-llu elitarput.",
        "translation": "Oh my, we eventually learned his song."
    },
    "139": {
        "startTime": 1681.537,
        "endTime": 1688.15,
        "transcript": "Waten tang atutullrulria tauna uurcaq tangvaurluku:",
        "translation": "You see, he would sing like this, watching that person with the signaling gaff:"
    },
    "140": {
        "startTime": 1688.487,
        "endTime": 1700.562,
        "transcript": "\"Uurca-raya-yarra-iya, aa-iya tan'guaravluarrlugaat",
        "translation": "\"One with signaling gaff raya-yarra-iya, aa-iya the many [?little boys]"
    },
    "141": {
        "startTime": 1700.749,
        "endTime": 1708.299,
        "transcript": "\"Issur-issur-issur-issur, makla-ssiya-yarra-iya",
        "translation": "\"Spotted seal-spotted seal-spotted seal-spotted seal, bearded seal-ssiya-yarra-iya"
    },
    "142": {
        "startTime": 1708.425,
        "endTime": 1714.087,
        "transcript": "\"Aa-iya, tan'guaravlaarrlugaat.\"",
        "translation": "\"Aa-iya, the many [?little boys].\""
    },
    "143": {
        "startTime": 1714.125,
        "endTime": 1719.062,
        "transcript": "Tua-i elicingqapiggluk' wangkuta niicugnistaini.",
        "translation": "We who listened to him completely learned it."
    },
    "144": {
        "startTime": 1721.449,
        "endTime": 1736.237,
        "transcript": "Uurcam-ll' imum tekicami urenkelluku ciuqerranun nang'arcami negcikcuaraminek, negcikcuarani kapuarrluku wavet elliqerluku qanemciluni.",
        "translation": "And when the one with the signaling gaff arrived, when he stood before him with intent, he stuck his gaff here and told a story."
    },
    "145": {
        "startTime": 1737.1,
        "endTime": 1742.912,
        "transcript": "Aqvalgirarkanek, aqvalgirarkat qanrulluki.",
        "translation": "He told the ones who would get them that there were things to get."
    },
    "146": {
        "startTime": 1743.449,
        "endTime": 1754.849,
        "transcript": "Tua-i aren imkut ircenrraat ciungatni pillret amllertatait ikamrat unuaquaqan ketmurrnaurtut.",
        "translation": "Oh my, sleds as many as the little people who had gone ahead of them would go to the ocean every day."
    },
    "147": {
        "startTime": 1755.112,
        "endTime": 1761.475,
        "transcript": "Amllertacirkait cunaw' tua-i waniw' ciungatni maniurluki tamakut.",
        "translation": "It turned out that they had shown how many would go as they went ahead of them."
    },
    "148": {
        "startTime": 1785.55,
        "endTime": 1789.037,
        "transcript": "Angalkurtellrulrianga qavamkun.",
        "translation": "I bested a shaman in my sleep."
    },
    "149": {
        "startTime": 1790.337,
        "endTime": 1794.45,
        "transcript": "Tua-i maaten tang im' ellangua, qanemcitnaamken.",
        "translation": "I came to, let me tell you the story."
    },
    "150": {
        "startTime": 1794.462,
        "endTime": 1801.362,
        "transcript": "Yuilqumi ellangua waten kiirrarma aqumgalrianga nunam qaingani.",
        "translation": "I came to in the wilderness, sitting all by myself on the ground."
    },
    "151": {
        "startTime": 1801.974,
        "endTime": 1809.224,
        "transcript": "Maaten tang caqalriamek niicama ukatmun takuyartua, amik una.",
        "translation": "When I heard something and turned my head this way, I saw a door here."
    },
    "152": {
        "startTime": 1809.737,
        "endTime": 1818.75,
        "transcript": "Talliq-wa tang man' tallirpilirneq nuna man' tua-i waten agturturluku agiirtellria.",
        "translation": "There was a right arm approaching, constantly touching the land here."
    },
    "153": {
        "startTime": 1819.037,
        "endTime": 1824.912,
        "transcript": "Umyuarteqa'artua, \"Aling aren, assilriarunripagta tanem man'a.\"",
        "translation": "I thought, \"My goodness, this is not something good.\""
    },
    "154": {
        "startTime": 1825.812,
        "endTime": 1835.587,
        "transcript": "Ayumian tekipailganga yaaqsiggaan piicaglua qavamni camani.",
        "translation": "Then, before it reached me since it was a little far, I prayed as I slept down there."
    },
    "155": {
        "startTime": 1835.6,
        "endTime": 1847.4,
        "transcript": "Atanermun ikayuusqellua, man'a-llu agiirtelria tekiteqatarteka wiinga ingluliurutkaanek eneqanaitnilua nallunritnilua.",
        "translation": "I prayed for the Lord to help me, and that I knew that I had nothing that could oppose this thing that was going to reach me."
    },
    "156": {
        "startTime": 1847.825,
        "endTime": 1855.137,
        "transcript": "Ayuqiikun ingluliurutkaitnilua, piniliisqellua tau͡gaam.",
        "translation": "I said that I had not the same power to oppose it, but to give me strength."
    },
    "157": {
        "startTime": 1855.712,
        "endTime": 1861.15,
        "transcript": "Pinimek cikiisqellua mat'um tungiinun.",
        "translation": "I asked to be given strength for this."
    },
    "158": {
        "startTime": 1884.425,
        "endTime": 1895.712,
        "transcript": "Taqngama uitua waten cetungqallemni irugma akuliigni uluaqa un' ulurpall'er.",
        "translation": "When I was done, I opened my eyes as I was sitting with outstretched legs liek this, and my knife, my huge knife, was between my legs."
    },
    "159": {
        "startTime": 1896.837,
        "endTime": 1902.162,
        "transcript": "Qaill' taun' tailarta? Amta-ll' wii yuilqumllua.",
        "translation": "How did that come? Despite my being in the wilderness."
    },
    "160": {
        "startTime": 1904.037,
        "endTime": 1906.749,
        "transcript": "Teguqerluku.",
        "translation": "I grabbed it."
    },
    "161": {
        "startTime": 1906.962,
        "endTime": 1912.637,
        "transcript": "Teguqaamku tangrraqa maa-i tua-i tekiteqatallinikiinga.",
        "translation": "When I grabbed it, I saw that it was going to reach me."
    },
    "162": {
        "startTime": 1913.025,
        "endTime": 1916.887,
        "transcript": "Atam tua-i caunqegcaqka.",
        "translation": "You see, I faced it head on."
    },
    "163": {
        "startTime": 1917.037,
        "endTime": 1930.437,
        "transcript": "Tua-i caungamku maa-i tua-i tekiteqataanga waten wavet ciisqumigglua uluaq waten epuakun tegukeka inglugtun.",
        "translation": "When I faced it as it was going to reach me, I knelt here and took the knife on the handle like this as an opponent."
    },
    "164": {
        "startTime": 1931.625,
        "endTime": 1939.537,
        "transcript": "Tuani piicaggaarlua uitellruunga ayuqucimtun ayuqevkenii tua-i pinirnganii-llu.",
        "translation": "When I opened my eyes after I had prayed, I felt different and seemed strong."
    },
    "165": {
        "startTime": 1942.837,
        "endTime": 1950.587,
        "transcript": "Tua-i-llu-wa tua-i maavet unatet elliata waten tallirpilirneret",
        "translation": "And then when the right hand came here"
    },
    "166": {
        "startTime": 1951.262,
        "endTime": 1956.562,
        "transcript": "Wavet uluaq tua-i waten piqerluku ellikeka.",
        "translation": "I did this with the knife and put it here."
    },
    "167": {
        "startTime": 1956.8,
        "endTime": 1965.362,
        "transcript": "Tua-i ellii-wa tua-i qiaryigtellria. Qelempaglua-ll' wii qiaryigtellria.",
        "translation": "It started crackeling. I shut my eyes tight as it was crackling."
    },
    "168": {
        "startTime": 1965.374,
        "endTime": 1970.724,
        "transcript": "Atam qiaryigquraqerluni nunamun kapuartellria.",
        "translation": "You see, as it was crackling, it stuck into the ground."
    },
    "169": {
        "startTime": 1971.337,
        "endTime": 1980.012,
        "transcript": "Call' im' qalriuciyaarluni, tuar caviyaaq-llu qalrialria tayima tuar qungagarrluni.",
        "translation": "It also cried out, and it seemed that the metal was crying out as it seemed to retreat."
    },
    "170": {
        "startTime": 1980.8,
        "endTime": 1984.5,
        "transcript": "Aren, takuya'rqa talliq im' tayima.",
        "translation": "Oh my, I turned my head and the arm was gone."
    },
    "171": {
        "startTime": 2007.687,
        "endTime": 2017.312,
        "transcript": "Waten pilaraitkut: wangkuta-gguq maa-i mat'um nalliini cetuun nuugakun, nuuganek umyuangukut.",
        "translation": "They say this to us: these days, we have the breadth of mind as a fingernail."
    },
    "172": {
        "startTime": 2017.324,
        "endTime": 2023.262,
        "transcript": "Umyuarput navkaryukaarluni, iqlutmuqercukaarluta.",
        "translation": "Our will of mind is easily destroys, and we easily go the wrong way."
    },
    "173": {
        "startTime": 2023.862,
        "endTime": 2033.224,
        "transcript": "Wangkuta ilumun qalarutetullruitkut au͡gkut anguqallemta nekayugnayuksuunata.",
        "translation": "Indeed, those we were born in time to see would speak to us without thinking we'd get offended."
    },
    "174": {
        "startTime": 2033.412,
        "endTime": 2037.737,
        "transcript": "Nunupiarnganata-llu qalarutetullruluta.",
        "translation": "And they would speak to us as if they really were scolding us."
    },
    "175": {
        "startTime": 2037.799,
        "endTime": 2049.212,
        "transcript": "Tayima ilavci man'a elitaqaa waten qanelqa: qarulluta taangarturalriarunritlemteńi.",
        "translation": "One of you probably recognizes it when I say this: let us encourage each other while we do not consume alcohol."
    },
    "176": {
        "startTime": 2050.537,
        "endTime": 2062.95,
        "transcript": "Peng'gartevkenata qalarutetullruitkut, umyuarput-llu qaillun nekayugnayukluta-llu piyuunata qalrutetullruitkut nunurnganata.",
        "translation": "They would speak to us without worrying, and they would speak to us as if scolding us without thinking that we would somehow get offended."
    },
    "177": {
        "startTime": 2063.812,
        "endTime": 2072.6,
        "transcript": "Tua-i waten nunupiarnganata qalaruqaarluta, waten kingunertetullruat taq'aqamegtekut:",
        "translation": "After they had spoken to us as if they were scolding us, they would say this after when they finished:"
    },
    "178": {
        "startTime": 2072.912,
        "endTime": 2084.012,
        "transcript": "\"Yuum-gguq tang kenkekni... qalarucuitaa qaillun ayuqengraan canganarqengraan kenkenrilkeńi qalarucuitaa.",
        "translation": "\"The one whom a person loves... a person does not teach one he does not love no matter what they're like or if they're misbehaving."
    },
    "179": {
        "startTime": 2084.05,
        "endTime": 2092.112,
        "transcript": "\"Yuum-gguq kenkeni qalarutetua waten nunurnganaku, nekayullerkaa-llu umyuaqevkenaku.\"",
        "translation": "\"A person teaches one whom he loves as if he is scolding, without thinking he will get offended.\""
    },
    "180": {
        "startTime": 2117.35,
        "endTime": 2124.212,
        "transcript": "Taangaq enurnarluku wiinga ellangellruunga, taangiqellriamek-llu tangeqsaunii.",
        "translation": "I grew up when alcohol was scarce, and I didn't see anyone drunk."
    },
    "181": {
        "startTime": 2124.549,
        "endTime": 2132.662,
        "transcript": "Tua-i-llu kinguqvaarni aipangvailegma-llu tangaangellruunga taangiq'lalrianek.",
        "translation": "And then later, before I wed, I started seeing people who would get drunk."
    },
    "182": {
        "startTime": 2133.374,
        "endTime": 2143.049,
        "transcript": "Tua-i niiqurluku ayagmek picurlautnguluku taangaq man'a ilumun naulluutmi mat'umi tukninrurtuq maa-i.",
        "translation": "We've heard from the beginning that alcohol brings misfortune, and it is truly more powerful than sickness today."
    },
    "183": {
        "startTime": 2143.075,
        "endTime": 2145.512,
        "transcript": "Pininrurtuq taangaq man'a.",
        "translation": "This alcohol has become stronger."
    },
    "184": {
        "startTime": 2145.525,
        "endTime": 2151.262,
        "transcript": "Cat-llu allat iiinrurrluut cali pininrurrluteng mat'umi naulluutmi.",
        "translation": "And other things, medicine abuse is also stonger than sickness."
    },
    "185": {
        "startTime": 2152.649,
        "endTime": 2161.837,
        "transcript": "Maa-i tua-i mat'um nalliini cangerliqvakarluteng maaken ayanrirtut yuut.",
        "translation": "Since they are facing very hard times these days, people aren't leaving here anymore."
    },
    "186": {
        "startTime": 2162.062,
        "endTime": 2172.537,
        "transcript": "Tau͡gaam taangiqluteng, kuingirrlugnek, allanek-llu iinrurrlugnek aturluteng maa-i ayalriit maaken nunamek amlleriut.",
        "translation": "Instead, there are now a lot of people leaving here to abuse alcohol, marijuana, and other things like medication."
    },
    "187": {
        "startTime": 2172.662,
        "endTime": 2179.487,
        "transcript": "Iliini-llu amllerrluteng quyurmeng ayagaqluteng niitaqluki wangkuta.",
        "translation": "And sometimes, we hear that a lot of them gather to travel."
    },
    "188": {
        "startTime": 2179.85,
        "endTime": 2186.599,
        "transcript": "Ilumun-lli mat'umi taangami tua-i assinrilnguuyaaqvaa atutustaini.",
        "translation": "Oh my, it truly is not a good thing for people who abuse alcohol."
    },
    "189": {
        "startTime": 2186.724,
        "endTime": 2191.199,
        "transcript": "Now, we are discussing alcohol.",
        "translation": "Now, we are discussing alcohol."
    },
    "190": {
        "startTime": 2191.249,
        "endTime": 2194.262,
        "transcript": "Wiinga nutaan quyurteliyanritua.",
        "translation": "This is not the first meeting I've attended."
    },
    "191": {
        "startTime": 2194.949,
        "endTime": 2201.074,
        "transcript": "Quyurteliyartura'arqama maa-i man'a taangaq callularyaaqerput.",
        "translation": "When I attend meetings, we fight against alcohol."
    },
    "192": {
        "startTime": 2201.25,
        "endTime": 2208.262,
        "transcript": "Niitellra-llu cali allat wangkuunrilnguut cali callularyaaqaat taangaq man'a.",
        "translation": "And from what we hear, other people aside from us also fight against alcohol."
    },
    "193": {
        "startTime": 2208.337,
        "endTime": 2211.687,
        "transcript": "Arenqiatuq assiilnguungami.",
        "translation": "It's distressing because it's a bad thing."
    },
    "194": {
        "startTime": 2212.612,
        "endTime": 2218.399,
        "transcript": "Pegtesciigat'laraa aturyaurtestiin. Tua-i pegtesciiganaku.",
        "translation": "One who begins to abuse it cannot give it up. He cannot give it up."
    },
    "195": {
        "startTime": 2218.462,
        "endTime": 2224.162,
        "transcript": "Tau͡gaam tua-i pingnaqellriim tayima pegtarkauyaaqaa.",
        "translation": "But one who tries will give it up."
    },
    "196": {
        "startTime": 2224.174,
        "endTime": 2229.474,
        "transcript": "Atunritengnaqestiin-llu atunrirarkauyaaqluku.",
        "translation": "And one who refrains from abusing it will stop abusing it."
    },
    "197": {
        "startTime": 2252.399,
        "endTime": 2262.849,
        "transcript": "Atam wiinga tua-i avani ella iqukluku qantullratni, anguanka au͡gkut ella iqukluku qantulriit",
        "translation": "You see, back when they talked about the world ending, I was born in time to see those who talked about the world ending"
    },
    "198": {
        "startTime": 2263.924,
        "endTime": 2271.999,
        "transcript": "Tamana-wa tua-i ak'a yaaqvani piitnaq qanrutketullrat, qanrutkelartai angullruanka tua-i.",
        "translation": "Way back when they talked about a time of need, I was born in time to see those who talked about it."
    },
    "199": {
        "startTime": 2272.387,
        "endTime": 2283.662,
        "transcript": "Tua-ll' tang ataucim tang au͡g'um qanellra tua-i tang waniwa umyuaqelgurikeka tang tua-i.",
        "translation": "And then, you see, now I always remember what that one person said."
    },
    "200": {
        "startTime": 2283.674,
        "endTime": 2292.274,
        "transcript": "Tua-i-ll' umyuaqelguriamku ella tang tua-i una aaryaguskeka iqukvanerrlugqurainarnayukluku.",
        "translation": "And then as I always remember it now, I am wary of this world, afraid that it will end badly."
    },
    "201": {
        "startTime": 2292.537,
        "endTime": 2299.85,
        "transcript": "Kiima-llu pinritliniluku. Tua-i ilaita aaryagutaat una ella.",
        "translation": "And it's apparently not just me. Some are not wary of this world."
    },
    "202": {
        "startTime": 2301.324,
        "endTime": 2316.262,
        "transcript": "Tua-i tamaani atam maaten murilkessagutua angukara'urluut arnassagaat ilait waten ciisqugni ayaperlukek piyuayaurrluteng, ilait tau͡gken piyuananrirluteng.",
        "translation": "When I started becoming observant back then, I noticed that some old men and old women would walk by supporting themselves with their knees, yet some could not walk anymore."
    },
    "203": {
        "startTime": 2316.574,
        "endTime": 2320.612,
        "transcript": "Arnassagangqetullratni angukara'urlungqerrluteng-llu.",
        "translation": "When they had old women and old men [among them]."
    },
    "204": {
        "startTime": 2321.337,
        "endTime": 2327.924,
        "transcript": "Ilait tegularluki qasgimek anulluki maqilallruut.",
        "translation": "Some would take them, bring them out of the community house, and take fire baths."
    },
    "205": {
        "startTime": 2328.087,
        "endTime": 2332.687,
        "transcript": "Taqngameng-llu cali itrulluki piyunanrilriit tamakut.",
        "translation": "And when they were done, they would bring in those who could not walk anymore."
    },
    "206": {
        "startTime": 2334.137,
        "endTime": 2340.887,
        "transcript": "Tua-ll' ella iqukluki qanllermeggni waten ilait qanellruut:",
        "translation": "Then when they spoke about the world ending, some of them said this:"
    },
    "207": {
        "startTime": 2340.9,
        "endTime": 2352.7,
        "transcript": "\"Tamaa-i-gguq tamakut ak'allaunqurrit tamatum tua-i ellam aciani, tamatum niitetullemta aciani yuullret,\"",
        "translation": "\"The oldest ones who had been alive under the earth, the place we heard about beneath,\""
    },
    "208": {
        "startTime": 2352.737,
        "endTime": 2362.3,
        "transcript": "Tamakut taukut ak'allaunqurrit qanertut, \"Yuk-gguq yuunertuqeryaaqaquq. Tamana-gguq aipiringaitaa.\"",
        "translation": "Those oldest ones said, \"A person lives for a long time. He will not do so again.\""
    },
    "209": {
        "startTime": 2362.399,
        "endTime": 2365.899,
        "transcript": "Tua-i cali waten qanertut:",
        "translation": "They also said this:"
    },
    "210": {
        "startTime": 2366.012,
        "endTime": 2374.762,
        "transcript": "\"Atam-gguq tamaani,\" ella iqukluku qantullratni tamaani ciuqvani,",
        "translation": "\"Back then, you see,\" when they spoke about the world ending way back then,"
    },
    "211": {
        "startTime": 2374.787,
        "endTime": 2378.924,
        "transcript": "\"Atam-gguq ilait makut nukalpiat,\"",
        "translation": "\"You see, some of these great hunters,\""
    },
    "212": {
        "startTime": 2379.999,
        "endTime": 2388.474,
        "transcript": "Waten qasgimi ellangyullerminek-llu qanelria tauna angukara'urluq un'gani caniqami qanelria niilluku",
        "translation": "That old man who was just waking in the community house, I heard him toward the door by the wall"
    },
    "213": {
        "startTime": 2388.524,
        "endTime": 2396.562,
        "transcript": "Ilii-gguq tau͡gaam maktaqellria, \"Aa, amci-llu-qaa piyuan tungenqegturanemteńi.\"",
        "translation": "They said that one of them got up, \"Ah, it should happen already during our good time.\""
    },
    "214": {
        "startTime": 2396.649,
        "endTime": 2400.749,
        "transcript": "Cunawa-gguq tamaa-i tamatum pistekameng mallgillrani.",
        "translation": "Apparently, it was when the one who would get them was nigh."
    },
    "215": {
        "startTime": 2400.849,
        "endTime": 2410.187,
        "transcript": "Yuut-gguq iciw' ilacingllermeggni-gguq cunawa. Ilaciqanricuitut-gguq yuut.",
        "translation": "Apparently, you know, they said that when people hoped for something. They said that people always hope for something."
    },
    "216": {
        "startTime": 2412.774,
        "endTime": 2419.012,
        "transcript": "Anucimirqecetaarumallerkameng-wa tua-i tamatum piciqiangaqateng mallgikateng.",
        "translation": "They said that they would beg to be liberated when that time was nigh."
    },
    "217": {
        "startTime": 2443.137,
        "endTime": 2451.924,
        "transcript": "Tua-ll' tamaani, tamaa-i tamatum nalliini, wiinga-ll' tua-i tamakut erenret tanglallruanka.",
        "translation": "And back that, at that time, I also used to see those days."
    },
    "218": {
        "startTime": 2451.937,
        "endTime": 2456.137,
        "transcript": "Tuar tang uksumi ataucimi pillrulriit.",
        "translation": "It seemed they did it in one winter."
    },
    "219": {
        "startTime": 2456.287,
        "endTime": 2467.499,
        "transcript": "Ernertangyaurtellruuq, waten erenrillermi kinguani qavaggun ernertangyarani kiatvaarrluku negrem tua-i tungiikun.",
        "translation": "The daytime came to be, upriver where the dawn would come, going upriver toward the north."
    },
    "220": {
        "startTime": 2467.512,
        "endTime": 2470.662,
        "transcript": "Ernekegtaarnek unuurrluni.",
        "translation": "From beautiful days, night would set."
    },
    "221": {
        "startTime": 2470.712,
        "endTime": 2478.999,
        "transcript": "Tua-i qanlartut ilait tamakut angutet erneruaryaurrniluku. Camek iquliqsaunaku.",
        "translation": "Some of them men would say that there are not false days. They wouldn't offer any explanation."
    },
    "222": {
        "startTime": 2479.212,
        "endTime": 2487.499,
        "transcript": "Tua-llam cat iliitni akusrarrluta tua-i naanguarluta tua-i tan'geriluni tua-i.",
        "translation": "And one day, we were rowdy, playing until it got dark."
    },
    "223": {
        "startTime": 2489.775,
        "endTime": 2495.387,
        "transcript": "Enemun tua-i, anglicartekellregma enekenrilkiignun iterlua.",
        "translation": "I entered a house that wasn't the house of those who had raised me."
    },
    "224": {
        "startTime": 2495.537,
        "endTime": 2500.187,
        "transcript": "Tua-i-ll' itqanemkun arnaq au͡gna iterluni kingumkun.",
        "translation": "And right when I went in, a woman came in after me."
    },
    "225": {
        "startTime": 2500.199,
        "endTime": 2506.437,
        "transcript": "Tua-ll' itrami kanani aqumvailegmi qanertuq, \"Tua-i-am keggna ernertanglliniuq.\"",
        "translation": "Then when she came in, she said before she sat, \"There is day out there now.\""
    },
    "226": {
        "startTime": 2506.55,
        "endTime": 2514.75,
        "transcript": "Tua-ll' tauna tamatum enem yuin angukara'urluat angukara'urluq qanertuq",
        "translation": "And then the old man among the people of that house, the old man said"
    },
    "227": {
        "startTime": 2514.874,
        "endTime": 2524.774,
        "transcript": "\"Ella-gguq una piarkaurtaqami yun'i-gguq nalluyurcivkayuitai. Tau͡gaam-gguq atam elpegcilirraatui.\"",
        "translation": "\"When it's time, nature does not keep its people in ignorance. Instead, you see, it gives them a sign.\""
    },
    "228": {
        "startTime": 2525.599,
        "endTime": 2539.325,
        "transcript": "Atam-gguq tamaa-i elpegcilirai tua-i tamana aturarkani. Ellangcautekani pinariata tua-i elliin yun'i tangerrluki makut nunami yuulriit tangerrluki tua-i pinariata.",
        "translation": "He said, you see, that it gives them a sign of what it's going to do. When it was time to teach them, looking at its people, because it's time, looking at the people living here on the earth."
    },
    "229": {
        "startTime": 2539.349,
        "endTime": 2544.924,
        "transcript": "Atam-gguq tamaa-i nasvagaa ellaitnun tua-i tamaa-i tamaaggun piarkaurrluki.",
        "translation": "You see, he said that it is showing them what will happen to them through that."
    },
    "230": {
        "startTime": 2545.174,
        "endTime": 2559.999,
        "transcript": "Tua-ll' qanertuq, \"Atam-gguq yuut neryuniuryaaqniartut. Atam-gguq neryuniuryaaqvimeggnek neryuniunrirniartut, neryuniulriartairulluni-llu.",
        "translation": "And then he said, \"You see, people will wait expectantly. You see, as they are waiting expectantly, they will wait no more, and no one left will be waiting expectantly."
    },
    "231": {
        "startTime": 2560.199,
        "endTime": 2565.824,
        "transcript": "\"Atam-llu-gguq ella iqukluku qanelriamek niitnanrirniartut.\"",
        "translation": "\"Also, you see, they will no longer hear anyone talking about the world ending.\""
    },
    "232": {
        "startTime": 2565.837,
        "endTime": 2571.375,
        "transcript": "Tua-i maa-i tamana taum qanellra tua-i nall'aringaarput.",
        "translation": "Now, we are in the time that he talked about."
    },
    "233": {
        "startTime": 2571.499,
        "endTime": 2578.188,
        "transcript": "Cali-llu-gguq atam qanikcangqerrnanrirniartuq.",
        "translation": "You see, he also said that there would be no snow anymore."
    },
    "234": {
        "startTime": 2578.399,
        "endTime": 2582.499,
        "transcript": "Wagg'uq ata ataucimun ellimangkuniu.",
        "translation": "In other words, when [nature] puts it into one place."
    },
    "235": {
        "startTime": 2582.511,
        "endTime": 2586.377,
        "transcript": "Tua-i taum qanellra waniwa tua-i umyuaqelguriaqa.",
        "translation": "Now, I always remember what he said."
    },
    "236": {
        "startTime": 2586.388,
        "endTime": 2589.355,
        "transcript": "Tua-i ella una aaryagutaqa.",
        "translation": "I am not wary of this world"
    },
    "237": {
        "startTime": 2589.366,
        "endTime": 2592.833,
        "transcript": "Wiinga ellam uum catacia nalluyaaqaqa.",
        "translation": "I actually don't know to how far along this world is."
    },
    "238": {
        "startTime": 2617.755,
        "endTime": 2620.288,
        "transcript": "Cali waten qanellruut.",
        "translation": "They also said this."
    },
    "239": {
        "startTime": 2621.254,
        "endTime": 2625.699,
        "transcript": "Meluk kiingan tua-i qanrutketullruat.",
        "translation": "They only talked about fish roe."
    },
    "240": {
        "startTime": 2625.71,
        "endTime": 2632.477,
        "transcript": "Meluk-gguq man'a tua-i allrakurtaaryaaqeciquq nunam iluani.",
        "translation": "They said that this fish row will appear every year on earth."
    },
    "241": {
        "startTime": 2632.488,
        "endTime": 2634.599,
        "transcript": "Tua-i-gguq cangaringaituq.",
        "translation": "They said it would not change."
    },
    "242": {
        "startTime": 2634.61,
        "endTime": 2643.255,
        "transcript": "Yuum iluanun alingnaringaituq nunam iluani tua-i allrakurtaange'rmi. Tua-i kiingan qanrutketullruat.",
        "translation": "They said it would not be dangerous to humans though it comes every year. That's all they would say about it."
    },
    "243": {
        "startTime": 2643.533,
        "endTime": 2648.299,
        "transcript": "Tua-ll' mat'um nalliini makut freezer-aat piyaaqut.",
        "translation": "And now, there are freezers."
    },
    "244": {
        "startTime": 2648.411,
        "endTime": 2653.177,
        "transcript": "Tau͡gaam malruugut makut. Freezer-aaq man'a malruuguq.",
        "translation": "But there are two kinds of these. There are two kinds of freezers."
    },
    "245": {
        "startTime": 2653.288,
        "endTime": 2661.299,
        "transcript": "Tau͡gaam una sulunaq umyuarteqaqama cali allrakurtaaryaaqmiciquq elluarrluni taryuumakuni.",
        "translation": "But when I think about this salted fish, it will also keep every year if it is salted right."
    },
    "246": {
        "startTime": 2661.31,
        "endTime": 2665.577,
        "transcript": "Allrakut tegulang'e'rmi tua-i cangaringailmiuq tauna.",
        "translation": "Though it takes on years, that will not spoil either."
    },
    "247": {
        "startTime": 2665.811,
        "endTime": 2670.611,
        "transcript": "Man'a-ggem tua-i freezer-aaq malruuguq. Catacia nallulartuq.",
        "translation": "There are two kinds of freezers. We don't know how far along they are."
    },
    "248": {
        "startTime": 2671.055,
        "endTime": 2680.277,
        "transcript": "Tua-ll' cali mat'um nalliini ukut aipaiput tua-i qagruyaaqut watua maa-i ernermi qak'mumi.",
        "translation": "And these days, our Caucasian counterparts are [qagret] out there in this day."
    },
    "249": {
        "startTime": 2680.288,
        "endTime": 2686.277,
        "transcript": "Tau͡gaam ayainanermeggni-wa nallunartuq.",
        "translation": "But as they go, we do not know what they do."
    },
    "250": {
        "startTime": 2686.455,
        "endTime": 2694.588,
        "transcript": "Umyuarteqaqama atam niicaurtellrianga ak'anek, ak'arrarnek tayim' ayaglua",
        "translation": "When I think about it, you see, I've started hearing since quite some time ago"
    },
    "251": {
        "startTime": 2694.633,
        "endTime": 2706.355,
        "transcript": "Ak'mum nunam wiinga tangssuilkeḿa yugyalriim nengllilangluni nengelmek nallulriim. Qanikaryaurrluni qanikcarmek nallulriim.",
        "translation": "The populous lands out there that I've never seen who do not know cold have started getting cold. It's started getting snowy where they do not know snow."
    },
    "252": {
        "startTime": 2706.355,
        "endTime": 2713.966,
        "transcript": "Tua-i tamakut naucetaat assircanrirai, cali-llu tayima piyagaat.",
        "translation": "That is causing harm to plants, and probably to young animals."
    },
    "253": {
        "startTime": 2714.422,
        "endTime": 2718.333,
        "transcript": "Tua-i cat cali piyugngalriit assircanrirai.",
        "translation": "It is also causing harm to those that were able."
    },
    "254": {
        "startTime": 2718.454,
        "endTime": 2730.354,
        "transcript": "Tayima akemkut wiinga tua-i tangssuilkeḿa yui nasperturluteng ellait, naugillertang-wa tua-i nasperturluku.",
        "translation": "The people in those lands way over there that I do not see are in heavy consideration, considering how to grow plants."
    },
    "255": {
        "startTime": 2730.4,
        "endTime": 2741.855,
        "transcript": "Umyuarteqaqama tamaańnguaqerlua, unguvaseng tunulluku Alaska-m yuinek arcaqakingaitut.",
        "translation": "When I imagine being there, they will not turn back from their lives and value Alaska's people."
    },
    "256": {
        "startTime": 2742.166,
        "endTime": 2750.554,
        "transcript": "Cali-am waten qanrutqerciullruunga, mumignganrilngurnek-am qanrutqerciullruunga elisngalriamek:",
        "translation": "I was also told this, I was told about this untranslated topic from someone who was knowledgeable:"
    },
    "257": {
        "startTime": 2750.777,
        "endTime": 2760.677,
        "transcript": "\"Naucetaalget-gguq naucetaamegteggun pimaarkaugut. Neqelget neqmegteggun pimaarkauluteng.",
        "translation": "\"Those who grow plants must grow plants. Those who food must go with their food.\""
    },
    "258": {
        "startTime": 2760.877,
        "endTime": 2770.455,
        "transcript": "Tua-ll' tauna waten cali qanertuq: \"Atam-gguq tamana mallguskan, tamana erneruaq naliuciiqiaqan",
        "translation": "And then he also said this: \"You see, when that time is nigh, when that false day is covered"
    },
    "259": {
        "startTime": 2770.466,
        "endTime": 2777.855,
        "transcript": "\"Atam-gguq yuut nepengniartut, tua-i ellalkangluteng. Camek atanqaanrirluteng.\"",
        "translation": "\"You see, people will start fighting, acting crazy. They will no longer await anything.\""
    },
    "260": {
        "startTime": 2777.855,
        "endTime": 2786.689,
        "transcript": "Tua-i tang maa-i man'a cali waten ayuqellria tua-i maa-i nall'aringaarput qakemkuni ernerni watua maa-i.",
        "translation": "You see how it is now, we are in that time during the current days out there."
    },
    "261": {
        "startTime": 2786.71,
        "endTime": 2789.399,
        "transcript": "Ilateng tua-i cakenrirluki.",
        "translation": "They do not care about those around them anymore."
    },
    "262": {
        "startTime": 2818.444,
        "endTime": 2828.133,
        "transcript": "Cali mat'um nalliini nallunaipagta. Maurluat una qanqerteńgunripagta.",
        "translation": "It is also clear these days. Their grandmother does not teach."
    },
    "263": {
        "startTime": 2828.188,
        "endTime": 2835.488,
        "transcript": "Cali-llu wangkurlumta tang apa'urlurluitni maani cailkami qanqerteńguvkenata.",
        "translation": "Neither are we pitiful ones, their grandfathers, teachers in random places here."
    },
    "264": {
        "startTime": 2835.499,
        "endTime": 2843.955,
        "transcript": "Tuarpiaq tang tua-i makut kingum yui, tuarpiaq tua-i tangvagluki anglanitekellriacetun ayuqluki.",
        "translation": "It truly seems that the people of the next generation, it seems like we are just watching them out of fun."
    },
    "265": {
        "startTime": 2843.966,
        "endTime": 2846.844,
        "transcript": "Inqautaunata mat'um nalliini.",
        "translation": "We have no sense of discipline these days."
    },
    "266": {
        "startTime": 2848.177,
        "endTime": 2862.544,
        "transcript": "Tua-ll' umyuarteqaqama ella una piciqiaquni waten uksuq man'a aturciqiange'rmiu yun'i qanrusngaitai maa-i watua piqatarniluki.",
        "translation": "And when I think about it, when the world is going to change, even if it's heading to winter, it will not tell its people what it's going to do."
    },
    "267": {
        "startTime": 2862.955,
        "endTime": 2875.288,
        "transcript": "Cunaw' tang tamaa-i ava-i ak'a tamalkuita pinrilnguunaki tamaa-i nasvallruamiu qanrulluki yun'i tamaaggun piarkaurrluki.",
        "translation": "It turns out, you see, that it would do any of them since it already showed and told its people that it would do that to them."
    },
    "268": {
        "startTime": 2875.621,
        "endTime": 2880.321,
        "transcript": "Tua-ll' cali waten qanertuq tauna angukara'urluq:",
        "translation": "And then, that old man also said this:"
    },
    "269": {
        "startTime": 2880.466,
        "endTime": 2894.655,
        "transcript": "\"Atam-gguq tamana tamaa-i mallguskan piitnaq waniwa-gguq ukuk ciiq, imarpinraq, atam-gguq kuignun neq'lirtuutengniartuq.",
        "translation": "\"You see, when that time of starvation is close, these two, shee, Bering cisco, there will be a lot of those fish in the rivers."
    },
    "270": {
        "startTime": 2894.655,
        "endTime": 2896.877,
        "transcript": "\"Neq'lirtuutengniartuk.\"",
        "translation": "\"There will be a lot of those fish.\""
    },
    "271": {
        "startTime": 2897.102,
        "endTime": 2905.582,
        "transcript": "Tua-i-gguq waten yuk nangulluni-w' tua-i taukuk aipaagnek neqkangqerrluni.",
        "translation": "They said that if a person runs out of food, he will have one of those as a food source."
    },
    "272": {
        "startTime": 2905.607,
        "endTime": 2909.477,
        "transcript": "Taukuk-gguq aipaagnek nerqaquciqsaaquq.",
        "translation": "They said that he would eat one of those."
    },
    "273": {
        "startTime": 2909.537,
        "endTime": 2914.247,
        "transcript": "Ilangcivkenani-gguq atam kemgiutniartuq, kemga iggniartuq.",
        "translation": "They said that despite that, he will become skinny, his flesh will deteriorate."
    },
    "274": {
        "startTime": 2914.257,
        "endTime": 2919.687,
        "transcript": "Neqek taukuk elluatuk assilriik, uqulgulutek-llu.",
        "translation": "Those two fish are appropriate and good, and they are fatty."
    },
    "275": {
        "startTime": 2919.997,
        "endTime": 2925.527,
        "transcript": "\"Tua-i-gguq,\" qanertuaq tauna, \"tua-i-gguq taukuk neqek piitnam tamatum neqek.\"",
        "translation": "\"Those,\" he said, \"Those two fish are the fish during famine.\""
    },
    "276": {
        "startTime": 2925.527,
        "endTime": 2928.167,
        "transcript": "Tua-i man'a avaullrunritaqa.",
        "translation": "I haven't forgotten this."
    },
    "277": {
        "startTime": 2928.382,
        "endTime": 2933.182,
        "transcript": "Maa-i-w' tua-i umyuaqelguriamku tua-i ella una aaryagutaqa.",
        "translation": "Since I've been remembering it now, I've become wary of this world."
    },
    "278": {
        "startTime": 2933.677,
        "endTime": 2945.077,
        "transcript": "Tua-ll' cali waten qanellruut au͡gkut: \"Ukut-gguq waniwa taryaqviinkut, iqalluunkut, qakiiyaankut, taukut-gguq piirtuyuitut.\"",
        "translation": "Then they also said this back then: \"These fish, king salmon, chum salmon, silver salmon, those do not [?].\""
    },
    "279": {
        "startTime": 2945.202,
        "endTime": 2952.002,
        "transcript": "Taumek-gguq maa-i watuam nalliini kingumta yuinun waten au͡gkut ellaita qanruyutekellruat:",
        "translation": "That's why, they said, the people back then passed on this traditional knowledge to the current people of our next generation:"
    },
    "280": {
        "startTime": 2952.137,
        "endTime": 2961.047,
        "transcript": "Taukut tua-i kuimallratni yuk piyugngakan qaategtevkenaku piyugngataciatun tamaaken tegutesqelluku.",
        "translation": "While those are swimming, if a person is able, he should not be lazy, but take as much as he can from them."
    },
    "281": {
        "startTime": 2961.097,
        "endTime": 2966.167,
        "transcript": "Inerquutekluku man'a uksuaq qagqesqevkenaku.",
        "translation": "They admonished them against [?] during the fall."
    },
    "282": {
        "startTime": 2966.207,
        "endTime": 2976.077,
        "transcript": "Tamana-gguq atam aturarkaukuniu uksuq tamakut tamaa-i kinguqliqtukait tamarmeng, atam-gguq cataitniartut.",
        "translation": "They said that type of winter is going to happen, everything that comes after them will be gone."
    },
    "283": {
        "startTime": 2976.157,
        "endTime": 2980.877,
        "transcript": "Man'a maa-i umyuaqelguriaqa.",
        "translation": "I always remember this now."
    },
    "284": {
        "startTime": 3006.382,
        "endTime": 3015.612,
        "transcript": "Tamatum tamaa-i piitnam tuskateng cali au͡gna waten qanqautesciullruugna. Ak'arraurtuq.",
        "translation": "They said that when famine comes upon them, I was also told about this. It's been a while."
    },
    "285": {
        "startTime": 3015.982,
        "endTime": 3026.752,
        "transcript": "Cali umyuamnun agtuutellruuq waten qanqautesteḿa qanqautaanga, elliin umyugaanun cali agtuutelliniuq waten qanerluni:",
        "translation": "It also touched my mind when the one who told me talked to me, and it also touched his mind when he said this:"
    },
    "286": {
        "startTime": 3026.822,
        "endTime": 3037.542,
        "transcript": "Tauna-gguq tang qavangurtulria kuvyaluni, tua-i waten atertelluni. Qaill' tua-i kuvyilarceta, kuvyilarceci.",
        "translation": "He said that he dreamt that he was fishing with a drift net, drifting in the water like this. However we or you fish with drift nets."
    },
    "287": {
        "startTime": 3037.847,
        "endTime": 3045.347,
        "transcript": "Tua-i-ll' pinariami imegluni. Imginanrani neqa kan'a alairtuq.",
        "translation": "Then when it was time, he rolled it. As he was rolling it, a fish appeared down there."
    },
    "288": {
        "startTime": 3045.502,
        "endTime": 3050.662,
        "transcript": "Enra tamiimek caquluteng, amta-ll' pektanqeggluni.",
        "translation": "It was [?entirely] covered in bones, yet it was moving."
    },
    "289": {
        "startTime": 3050.817,
        "endTime": 3060.027,
        "transcript": "Tua-ll' alairami qanrutlinia tauna cangtaqesteńi, \"Uitaqaa. Malrugnek qanerkangqertua.\"",
        "translation": "Then when it appeared, it said to the one who caught it, \"Wait. I have two things to say.\""
    },
    "290": {
        "startTime": 3060.317,
        "endTime": 3071.877,
        "transcript": "Tua-ll' pillinia tauna cangtaqesteńi, \"Tayima-gguq allrakut amllenrilnguut kinguatni piitnaq tut'eqatartuq.",
        "translation": "Then it said to the one who caught it, \"After a few years, a famine will come."
    },
    "291": {
        "startTime": 3071.952,
        "endTime": 3075.322,
        "transcript": "\"Cali-llu tegelgem yua pekteqatarluni.\"",
        "translation": "\"Also, the spirit of theft will move.\""
    },
    "292": {
        "startTime": 3075.332,
        "endTime": 3088.382,
        "transcript": "Atam au͡gkut wiinga tua-i angullrenka, anguyaaqekenka tua-i qanqaquuryaaqellriameng nutaan atam wiinga tegelgem yuanek niitellrianga.",
        "translation": "You see, of all the people I grew up in time to see who have always spoke, this was the first time I heard about the spirit of theft."
    },
    "293": {
        "startTime": 3088.572,
        "endTime": 3100.172,
        "transcript": "Tua-ll' taum tua-i qanqautestellma mat'um kinguani, tuar tang maa-i yuut allamiaqan tuar tang arcarikanilalriit. Tuar tang arcarikanilalriit.",
        "translation": "Then after the person who told me that, it seems that every year, people are getting worse. They seem to get worse."
    },
    "294": {
        "startTime": 3100.227,
        "endTime": 3105.527,
        "transcript": "Waten ilateng qinuuqluki, teglegiluki neqairluki tuaten.",
        "translation": "They've become reluctant to share with their families, even stealing food."
    },
    "295": {
        "startTime": 3105.612,
        "endTime": 3115.222,
        "transcript": "Yuut maa-i watua umyuarteqaqama mayiteqkuneng uuggun aqsaqumegteggun qaillun pitaqatartat?",
        "translation": "When I think about the people now, if their stomachs are deprived, how far will they go?"
    },
    "296": {
        "startTime": 3115.222,
        "endTime": 3117.462,
        "transcript": "Ilateng-llu allurtelarciqait.",
        "translation": "They will also steal from their families."
    },
    "297": {
        "startTime": 3117.477,
        "endTime": 3130.047,
        "transcript": "Wall'u tua-i yuut makut avanicetun ayuqenrirtut. Ilait uluryairulluteng, ilait-ll' alingnariluteng, ilii-llu neqrangqerrniluni tuqutauciquq-llu.",
        "translation": "Or, people are not like how they were before. Some have no more social inhibitions, and some have become dangerous, and some will be killed because they have food."
    },
    "298": {
        "startTime": 3130.557,
        "endTime": 3134.267,
        "transcript": "Tua-i taklirivakartuq. Waten pitaaqa.",
        "translation": "It's getting too long. That's all for that."
    },
    "299": {
        "startTime": 3157.307,
        "endTime": 3167.327,
        "transcript": "Tua-i qanrucunailkelallrit tamaaggun tua-i niiteksaitelallratgun tangvalallruanka.",
        "translation": "I would watch them rejecting advice, and being disobedient."
    },
    "300": {
        "startTime": 3167.382,
        "endTime": 3171.492,
        "transcript": "Nallunritellruanka yuk'egtauvkenateng.",
        "translation": "I knew they weren't good people."
    },
    "301": {
        "startTime": 3171.592,
        "endTime": 3174.442,
        "transcript": "Ilameggnek ayuqniarluteng.",
        "translation": "They covet their peers."
    },
    "302": {
        "startTime": 3174.472,
        "endTime": 3184.572,
        "transcript": "Catulrianek pitulrianek ayuqniarluteng anrutamegteggun wall' qaimegteggun yuulallruut",
        "translation": "They would covet those who worked and provided through their stomachs or their bodies [with ragged clothes]"
    },
    "303": {
        "startTime": 3184.917,
        "endTime": 3195.597,
        "transcript": "Tamakut qanruyutem artuqai, tamakut ellmeggnek maligtaqutenrilnguut qanruyutmeggnun.",
        "translation": "Those who were unable to follow traditional wisdom, those who did not obey the wisdom passed down to them."
    },
    "304": {
        "startTime": 3196.012,
        "endTime": 3201.592,
        "transcript": "Nangteqluteng yuulallruut elluamyivkenateng.",
        "translation": "They lived in suffering, not living right."
    },
    "305": {
        "startTime": 3201.917,
        "endTime": 3212.017,
        "transcript": "Tua-i imkurluteng camek enuqiuterluteng, ca tamalkuan enuqiutekluku.",
        "translation": "You know, they were in need of things, were in need of everything."
    },
    "306": {
        "startTime": 3212.582,
        "endTime": 3217.082,
        "transcript": "Tua-i waten ak'anun-llu yuuyuunateng.",
        "translation": "They wouldn't live long either."
    },
    "307": {
        "startTime": 3217.407,
        "endTime": 3223.497,
        "transcript": "Ak'anun unguvayuunateng tuaten umyuarteng aturluku yuulriit.",
        "translation": "They wouldn't live long, those who followed their minds like that."
    },
    "308": {
        "startTime": 3223.977,
        "endTime": 3232.097,
        "transcript": "Ak'anun unguvayuunateng. Tang ilumun tua-i piciutacia au͡gkut qanrutkelallrat.",
        "translation": "They wouldn't live long. You see, that's how true what the people back then talked about is."
    },
    "309": {
        "startTime": 3232.492,
        "endTime": 3235.132,
        "transcript": "Ak'anun unguvayuunateng.",
        "translation": "They wouldn't live long."
    },
    "310": {
        "startTime": 3235.407,
        "endTime": 3241.037,
        "transcript": "Tua-i naulluungualukarluteng-llu yuunriq'raqluteng catairtaqluteng.",
        "translation": "They would also pass away easily with minor sicknesses."
    },
    "311": {
        "startTime": 3265.097,
        "endTime": 3271.397,
        "transcript": "Tua-i niitelalqa aturluku waniwa ayuqeqcaaralarnilua.",
        "translation": "They said that I would do what [instructions] I heard."
    },
    "312": {
        "startTime": 3271.782,
        "endTime": 3284.692,
        "transcript": "Wiinga-llu aliayulqa maliggluku yuukuma tua-i wangnek pingaitelliniama imkut tau͡gaam ayagcianka nangtarkaulliniamki",
        "translation": "If I live according to my loneliness, I will not be doing it to myself, but will cause suffering to those who have departed from me"
    },
    "313": {
        "startTime": 3285.182,
        "endTime": 3289.012,
        "transcript": "Waten nangteqelqa maliggluku yuukuma.",
        "translation": "If I live according to my suffering like this."
    },
    "314": {
        "startTime": 3289.582,
        "endTime": 3302.052,
        "transcript": "Nangtarkaulliniamki waniw' tua-i waten canrilngurnun nugglua, umyuameggnek utumalrianek, utumalriit nuggvikluki.",
        "translation": "Since I would cause suffering to them, I should support myself to those who are good, who are mentally healthy, support myself with those who are healthy."
    },
    "315": {
        "startTime": 3302.252,
        "endTime": 3308.432,
        "transcript": "Waniw' tua-i ayuquralarnilua waten waniw' elliryaaqeng'e'rma naparma.",
        "translation": "They say that I am like this now, though I have reached this age still standing."
    },
    "316": {
        "startTime": 3308.867,
        "endTime": 3317.357,
        "transcript": "Tua-i-gguq ilumun yuum ayuqucia tua-i ava-i maniqerniluku-am qanertuq.",
        "translation": "Indeed, he said that he showed what a person is like."
    },
    "317": {
        "startTime": 3318.027,
        "endTime": 3321.147,
        "transcript": "\"Yuum-gguq ayuqucia ilumun manian.\"",
        "translation": "\"You are truly showing what a person is like.\""
    },
    "318": {
        "startTime": 3321.192,
        "endTime": 3332.962,
        "transcript": "Ilii-gguq man'a yuum waten tua-i umyaumi aliayullra maligtaquurpakarluku yuulria",
        "translation": "They said that some people who live according to their loneliness too much"
    },
    "319": {
        "startTime": 3333.182,
        "endTime": 3341.472,
        "transcript": "Aliayullni maligtaquurpakarluku yuulria egilrallra-llu-gguq cukalartuq.",
        "translation": "They say that a person who lives according to his loneliness too much goes through [life] quickly."
    },
    "320": {
        "startTime": 3341.522,
        "endTime": 3347.722,
        "transcript": "Ilumun tua-i ayuqucianek-am qanqa'urlurtuq mikelnguuyaaqluni imna.",
        "translation": "A child spoke truly about what a person is like."
    },
    "321": {
        "startTime": 3348.457,
        "endTime": 3355.932,
        "transcript": "Wangni mikelnguuyaaqluni tan'ga'urluullra im' canimelnguq, canimecaaqelria",
        "translation": "He was a child to me since it hasn't been long since he was a boy."
    },
    "322": {
        "startTime": 3355.932,
        "endTime": 3368.082,
        "transcript": "Piaqa-am tangerrluku, \"Tua-i waniw' tangerqevnga. Caunricaaqelriaten elpet cayaqlirluten-llu yuurtellruavet.",
        "translation": "I looked at him and said, \"You see me now. You may seem insignificant because you were born so late."
    },
    "323": {
        "startTime": 3368.662,
        "endTime": 3381.422,
        "transcript": "\"Tua-i man'a maa-i qanruyukar waten taringecurlanrilngurmi uitaarkaucia-am waniw' eneqaqercet'laqen waten qanraqavet.",
        "translation": "\"You make me remember that traditional wisdom must not be misunderstood when you say this."
    },
    "324": {
        "startTime": 3382.067,
        "endTime": 3383.842,
        "transcript": "\"Atawauguten.",
        "translation": "\"You're a good person."
    },
    "325": {
        "startTime": 3383.842,
        "endTime": 3391.712,
        "transcript": "\"Kiirrarpet-llu napacin cali una napangucin angurrluk' uuruteksaqunaku ilunga'urluung.\"",
        "translation": "\"Also, never [?regret] the fact that you are standing alone, dear cousin.\""
    },
    "326": {
        "startTime": 3391.712,
        "endTime": 3402.312,
        "transcript": "Pila'arqa-am, \"Uuruteksaqunaku. Iqua tekicungkumteggu tua-i tekiskumteggu kingunratgun imkut maligciiqapuk.\"",
        "translation": "I say to her, \"To not [?regret] it. When we're near the end, when we reach it, we will go after them.\""
    },
    "327": {
        "startTime": 3427.067,
        "endTime": 3437.297,
        "transcript": "Asgurtalriit tau͡gaam qanruyutmeggnek tua-i tuaten ayuqelartut, cam enurluki.",
        "translation": "Only those who doubt the traditional wisdom passed down to them are like that, being in need of things."
    },
    "328": {
        "startTime": 3437.837,
        "endTime": 3447.837,
        "transcript": "Cam enurluki, camek piicugluteng. Tua-i piilutiit piluni paivngayugpagluni.",
        "translation": "Things are scarce for them, and they have nothing. They are always without things."
    },
    "329": {
        "startTime": 3448.222,
        "endTime": 3457.982,
        "transcript": "Cali man'a akusrarun maa-i ilaitnek yuut allurqengelriatun ayuqelartuq atu'urkaatnek.",
        "translation": "Also, this mischievous behavior now, it's like it steals what some people need."
    },
    "330": {
        "startTime": 3458.247,
        "endTime": 3463.447,
        "transcript": "Tuar atu'urkarteng akusrarcullermeggnun navrutaqluku.",
        "translation": "It's like they trade what they need to use for mischief."
    },
    "331": {
        "startTime": 3463.842,
        "endTime": 3471.172,
        "transcript": "Navrulluku tua-i atu'urkarugateng imkut akusrarcullermeggnun tun'aqluki.",
        "translation": "They trade what they need to use, giving them to their mischevious behavior."
    },
    "332": {
        "startTime": 3471.452,
        "endTime": 3482.162,
        "transcript": "Akleng cali maa-i akusrarculriit mat'umek apqiitnek taangamek, mat'umek-llu kuingill'e'rmek.",
        "translation": "Poor things, they are now misbehaving with what they call alcohol, and this marijuana."
    },
    "333": {
        "startTime": 3482.452,
        "endTime": 3489.582,
        "transcript": "Tuarpiaq tang imna tamatum im'um aturyuk'ngaata anguyakai.",
        "translation": "It truly seems that what they want to abuse is waging war against them."
    },
    "334": {
        "startTime": 3490.132,
        "endTime": 3496.052,
        "transcript": "Tua-i ellmeggnek anernerteng-llu tunelriatun ayuqaqluku tamaaggun.",
        "translation": "It's like they give their own spirits through that."
    },
    "335": {
        "startTime": 3497.207,
        "endTime": 3502.687,
        "transcript": "Tua-i pillerkaa ukatairrluku tayim' nalluyagutaqluku.",
        "translation": "They pass by what they should do and forget it."
    },
    "336": {
        "startTime": 3505.932,
        "endTime": 3516.222,
        "transcript": "Maa-i tua-i yuut ayuquciqsaguskiit man'a, man'a maa-i taangaq, kuingill'e'rmek call' mat'umek aipirluku.",
        "translation": "Now, people have become alcoholics, coupling it with what they call marijuana."
    },
    "337": {
        "startTime": 3516.292,
        "endTime": 3526.332,
        "transcript": "Umyugaitnarqelria man'a atungnaqu'urluku ayuqelriit tua-i anernerteng kep'laqiit tamaaggun-llu.",
        "translation": "Those who continuously abuse mentally impairing things also take their own lives through that."
    },
    "338": {
        "startTime": 3526.557,
        "endTime": 3535.347,
        "transcript": "Imutun kepelriatun ayuqelaqiit. Qununaqsaaqaqluteng cakneq kingunrulriani.",
        "translation": "It's like they take their own lives. It is very heartbreaking to part with the younger generation."
    },
    "339": {
        "startTime": 3558.727,
        "endTime": 3564.157,
        "transcript": "Cali-llu waten wangnek wii atrartessiyaalallrullinilua.",
        "translation": "Also, I would apparently put myself down too much."
    },
    "340": {
        "startTime": 3564.157,
        "endTime": 3571.007,
        "transcript": "Taumek maa-i ayagyuat wii tuaten pisqumanritanka, ellait kemyukevkenaki pisqevkenaki.",
        "translation": "That's why I don't want young people do to that now, telling them not to think themselves incapable."
    },
    "341": {
        "startTime": 3571.057,
        "endTime": 3577.687,
        "transcript": "Tau͡gaam piluki assirluki, kemyukluki-llu ellaitnek pisqelluki.",
        "translation": "Instead, I tell them to treat themselves well, and to believe they are capable."
    },
    "342": {
        "startTime": 3577.747,
        "endTime": 3584.677,
        "transcript": "Waten-llu nasaurlullraullemni ilanka nasaurlullgutenka ilalillrunritanka.",
        "translation": "Also, when I was a girl like this, I would associate with my fellow girls."
    },
    "343": {
        "startTime": 3585.087,
        "endTime": 3589.847,
        "transcript": "Tua-i-wa akuliitni tangniillrussiyaagnayuklua.",
        "translation": "It was because I thought I wouldn't be as pretty among them."
    },
    "344": {
        "startTime": 3589.872,
        "endTime": 3592.252,
        "transcript": "Tamaa-i umyuaqelallrenka.",
        "translation": "Those are my memories."
    },
    "345": {
        "startTime": 3592.567,
        "endTime": 3597.682,
        "transcript": "Cali-llu akusrartellrianun ilautellrunritua.",
        "translation": "I also didn't join those who were mischievous."
    },
    "346": {
        "startTime": 3597.682,
        "endTime": 3602.512,
        "transcript": "Aquilriani-llu tan'germi ilautellrunritua.",
        "translation": "I also didn't join those who played outside in the dark."
    },
    "347": {
        "startTime": 3602.522,
        "endTime": 3610.382,
        "transcript": "Yuilqumi tau͡gaam tamaa-i tamaantelallemteńi tua-i kiingan ellu'urtaaryaraq wii pikellruaqa equgtaryaraq-llu.",
        "translation": "But when we were in the wilderness, I would only slide and gather wood."
    },
    "348": {
        "startTime": 3610.617,
        "endTime": 3615.987,
        "transcript": "Tua-i-ll' pissuryaraq pikellruluku.",
        "translation": "I would also hunt."
    },
    "349": {
        "startTime": 3615.987,
        "endTime": 3624.877,
        "transcript": "Taumek wani ayagyuani assiilkevkenaci elpeceńek tau͡gaam assikluci pilaqici.",
        "translation": "That why, young people, do not dislike yourselves, but treat yourselves well."
    },
    "350": {
        "startTime": 3624.947,
        "endTime": 3637.797,
        "transcript": "Cali-llu umyuaqelaquvciki atunrilngerpeciki aturciqaci tamakut cat assiitellriit ullaganrilkuvciki tegulanrilkuvciki-llu.",
        "translation": "Also, if you remember them, even if you don't do them, you may do bad things if you don't go to them or take them."
    }
};